const atomic = require('../../../git_modules/@tomandco/atomic/config/color');

/**
 * Not all colors are used to generate atomic classes
 *
 * Use named colors in SCSS files by `get` function
 * @example
 * ```css
 *   .class {
 *     color: get('namedColor.abbey');
 *   }
 * ```
 *
 * All colour variable names should come from http://chir.ag/projects/name-that-color/
 *
 */
const namedColor = {
    mineShaft: '#212121', // 1
    scorpion: '#595959', // 11, 43
    silverChalice: '#ACACAC', // 12
    redOrange: '#FF2F2F', // 2
    malachite: '#00BB1E', // 3
    wildSand: '#F6F5F5', // 4, 5
    alabaster: '#FAFAFA', // 41, 51
    iron: '#CFD2D3', // 42
    silver: '#CECDCD', // 52
    mercury: '#E1E1E1', // 53
    claret: '#8E1538', // 6
    codGray: '#1F1D1D', // 54
    mineShaft2: '#332E2E', // 55
    oldGold: '#D4AF37', // 7
    midnightExpress: '#202945', // 56
    concrete90: 'rgba(255, 255, 255, 0.9)'
};
exports.namedColor = namedColor;

/**
 * Thouse colors are used to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 *
 * @example
 * ```css
 *   .col-1 { color: #454647; }
 * ```
 */
const color = [
    // default colors from atomic
    ...atomic.color,
    // Primary
    { key: '1', value: namedColor.mineShaft, title: 'Mine Shaft', group: 'Primary' },
    { key: '11', value: namedColor.scorpion, title: 'Scorpion', group: 'Primary' },
    { key: '12', value: namedColor.silverChalice, title: 'Silver Chalice', group: 'Primary' },
    // System colours
    { key: '2', value: namedColor.redOrange, title: 'Red Orange - Error Color', group: 'System Colours' },
    { key: '3', value: namedColor.malachite, title: 'Malachite - Success Color', group: 'System Colours' },
    // Borders & Icons
    { key: '4', value: namedColor.wildSand, title: 'Wild Sand', group: 'Borders & Icons' },
    { key: '41', value: namedColor.alabaster, title: 'Alabaster', group: 'Borders & Icons' },
    { key: '42', value: namedColor.iron, title: 'Iron', group: 'Borders & Icons' },
    { key: '43', value: namedColor.scorpion, title: 'Scorpion', group: 'Borders & Icons' },
    // { key: '44', value: '#ffffff', title: 'White', group: 'Borders & Icons' }, // hidden cause its not defined
    // brand colors
    { key: '5', value: namedColor.wildSand, title: 'Wild Sand', group: 'Backgrounds' },
    { key: '51', value: namedColor.alabaster, title: 'Alabaster', group: 'Backgrounds' },
    { key: '52', value: namedColor.silver, title: 'Silver', group: 'Backgrounds' },
    { key: '53', value: namedColor.mercury, title: 'Mercury', group: 'Backgrounds' },
    // brand colors - trade
    { key: '54', value: namedColor.codGray, title: 'Cod Gray', group: 'Backgrounds' },
    { key: '55', value: namedColor.mineShaft2, title: 'Mine Shaft', group: 'Backgrounds' },
    { key: '56', value: namedColor.midnightExpress, title: 'Midnight Express', group: 'Backgrounds' },
    // accent
    { key: '6', value: namedColor.claret, title: 'Claret', group: 'Accent' },
    { key: '62', value: '#D84F19', title: 'Orange Roughy', group: 'Accent' },
    // reviews
    { key: '7', value: namedColor.oldGold, title: 'Old Gold', group: 'Reviews' }
];
exports.color = color;
